<i18n>
{
  "en": {
    "manager": "Manager",
    "accountSetting": "Setting",
    "toggleGroup": "Group",
    "logOut": "Logout",
    "groupManage": "Group Manage"
  },
  "zh": {
    "manager": "管理员",
    "accountSetting": "账号设置",
    "toggleGroup": "切换组织",
    "logOut": "退出登录",
    "groupManage": "组织管理"
  }
}
</i18n>
<template>
  <div id="header">
    <div class="container header-container">
      <img
        class="logo"
        src="@/assets/logo.jpg"
        alt=""
      >
      <div class="header-nav">
        <MenuItem>
          <a
            :href="msgRoute"
            target="_blank"
            class="iconfont icon-email_outline"
            style="position: relative;"
          >
            <span
              v-if="notice.msg > 0"
              class="notice-msg"
            >{{ notice.msg }}</span>
          </a>
        </MenuItem>
        <MenuItem>
          <div
            class="el-icon-question"
            style="position: relative; font-size: 20px; color: #fff; text-decoration: none;"
            @click="handleIsShow"
          >
            <span
              v-if="imNotice > 0"
              class="notice-msg"
            >{{ imNotice }}</span>
          </div>
        </MenuItem>
        <MenuItem @click="toggleLanguage(language === 'zh' ? 'en' : 'zh')">
          {{ language === 'zh' ? '中文' : 'EN' }}
        </MenuItem>
        <SubMenu ref="submenu">
          <MenuItem
            slot="title"
            class="user"
          >
            <el-image
              :src="user.avatar"
              class="user-avatar"
            >
              <div
                slot="error"
              >
                <i class="el-icon-user user-avatar-error" />
              </div>
            </el-image>
            <div
              v-if="currentRole === 'COMPANY'"
              class="user-name"
            >
              <span>{{ company.company_name }}</span>
              <span class="user-name-small">{{ user.username }} {{ company.role }}</span>
            </div>
            <div
              v-else
              class="user-name"
            >
              <span>{{ user.username }}</span>
            </div>
            <i class="user-icon-down el-icon-arrow-down" />
          </MenuItem>
          <SubMenu>
            <div
              slot="title"
              class="header-submenu-item"
            >
              <i class="menu-icon iconfont icon-group" />{{ $t('toggleGroup') }}
              <i class="header-submenu-arrow el-icon-arrow-right" />
            </div>
            <div
              class="header-submenu-item"
              @click="toggleCurrentRole('USER');"
            >
              {{ user.username }}
              <i
                v-if="currentRole === 'USER'"
                class="icon-select el-icon-check"
              />
            </div>
            <div
              v-if="company.company_name"
              class="header-submenu-item toggle-commany-item"
              @click="toggleCurrentRole('COMPANY');"
            >
              {{ company.company_name }}
              <i
                v-if="currentRole === 'COMPANY'"
                class="icon-select el-icon-check"
              />
            </div>
            <a
              :href="memberManagerRoute"
              target="_blank"
              class="header-submenu-item"
            >
              {{ $t('groupManage') }}
            </a>
          </SubMenu>
          <a
            :href="profileRoute"
            target="_blank"
            class="header-submenu-item"
          >
            <i class="menu-icon el-icon-user-solid" />{{ $t('accountSetting') }}
          </a>
          <a
            href="/ssoClient/logout"
            class="header-submenu-item"
          >
            <i class="menu-icon iconfont icon-exit" />{{ $t('logOut') }}
          </a>
        </SubMenu>
      </div>
    </div>
  </div>
</template>

<script>
import {
  mapState,
  mapMutations,
} from 'vuex';
import MenuItem from './HeaderMenu';
import SubMenu from './HeaderSubMenu';

export default {
  components: {
    MenuItem,
    SubMenu,
  },
  data() {
    return {
      activeIndex: '1',
      msgRoute: `${process.env.VUE_APP_UDC_URL}/#/messages/unread_msg?status=0`,
      memberManagerRoute: `${process.env.VUE_APP_UDC_URL}/#/corporation/corporation_index`,
      profileRoute: `${process.env.VUE_APP_UDC_URL}/#/account/profile`,
      isShow: false,
      clientId: '3',
      childUrl: 'https://im.cocos.com',
      imNotice: 0,
      imUrl: `${window.location.protocol}//im.cocos.com/auth/login?redirect_url=${window.location.protocol}//im.cocos.com`,
      popupwin: '',
    };
  },
  computed: {
    ...mapState(['language',
      'currentRole',
      'user',
      'company',
      'notice']),
  },
  mounted() {
    window.addEventListener('message', this.handleMessage);
  },
  destroyed() {
    window.removeEventListener('message', this.handleMessage);
  },
  methods: {
    ...mapMutations([
      'toggleLanguage',
      'toggleCurrentRole',
    ]),
    handleIsShow() {
      this.popupwin = window.open(this.imUrl, 'cocosIm');
    },
    handleMessage(event) {
      if (event.data === 'clientId') {
        this.sendMessage();
      } else if (typeof event.data === 'number') {
        this.imNotice = event.data;
      }
    },
    sendMessage() {
      this.popupwin.postMessage(this.clientId, this.childUrl);
    },
  },
};
</script>

<style lang="scss">
.toggle-commany-item {
  position: relative;
  &:after {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 1px;
    background: #fff;
    content: '';
  }
}
.notice-msg {
  position: absolute;
  top: -8px;
  right: -15px;
  color: #fff;
  font-size: $fontsize-sm;
  background: $color-danger;
  line-height: 1;
  padding: 2px 6px;
  border-radius: 20px;
}

.el-dialog {
  overflow: hidden!important;
  height: 580px;
  .el-dialog__header {
    // height: 20px;
    background: #6474e7!important;
    padding: 10px;
    .el-dialog__title {
      // font-size: 18px!important;
      font-weight: 700!important;
    }
    .el-dialog__headerbtn {
    top: 10px;
    .el-dialog__close {
      font-size: 24px;
      color: aliceblue!important;
    }
  }
  }
  .el-dialog__body {
    padding: 0!important;
    overflow: hidden;
  }
}

</style>
